import styled, { css } from 'styled-components'
import { PrimaryButton, OutlineButton, SecondaryButton } from '@chegg/fanta'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { ChevronIcon, ExportIcon, spacing, colors } from '@chegg-ui/theme'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import { AspiraStack, TimesNewRomanStack } from '@chegg-wt/core/theme/fanta/fonts'
import { PageHeaderWrapper } from '../Layouts/styled'

export const CitationListContainerWrapper = styled.div`
  ${AspiraStack};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor19};
  padding-bottom: ${spacing.px64};
`
export const CitationListBoxContainer = styled.main`
  max-width: 918px;
  margin: ${FantaTheme.spacing.fanta.xl} auto 0;

  @media (max-width: 999px) {
    width: 90%;
  }
`

export const CitationBox = styled.div`
  border: solid 1px ${FantaTheme.colors.greyLight};
  box-shadow: 0 0 4px rgba(34, 34, 34, 0.24);
  min-height: 574px;
  margin-top: ${FantaTheme.spacing.fanta.lg};
  background-color: ${colors.white};
`

export const CitationCTAContainer = styled.div`
  display: flex;
  padding: ${FantaTheme.spacing.fanta.lg} ${FantaTheme.spacing.fanta.xl};
  justify-content: space-between;
  align-items: center;

  @media (max-width: 700px) {
    flex-wrap: wrap;
  }

  @media (max-width: 599px) {
    flex-direction: column;
    align-items: center;
  }
`
export const CitationButtonCTAContainer = styled.div`
  display: flex;
  > div,
  > button {
    padding: 0 ${FantaTheme.spacing.fanta.sm};
  }

  @media (max-width: 599px) {
    flex-direction: column;
    align-items: center;

    > div > button,
    > button {
      width: 333px;
    }
    > button {
      padding: 12px 30px !important;
    }
    > div {
      padding: ${FantaTheme.spacing.fanta.sm};
    }
  }

  @media (max-width: 450px) {
    width: 100%;
    > div > button,
    > button {
      width: 100%;
    }
    > div {
      width: 100%;
      padding: ${FantaTheme.spacing.fanta.sm} 0 0 0;
    }
    > div > button {
      padding: ${FantaTheme.spacing.fanta.sm} 0 0 0;
    }
  }
`
export const CitationUtilityCTAContainer = styled.div`
  display: flex;
  @media (max-width: 700px) {
    margin-top: ${FantaTheme.spacing.fanta.sm};
  }

  @media (max-width: 599px) {
    margin-top: 0;
  }
`
export const CreateCitationButton = styled(PrimaryButton)`
  border-radius: 8px;
  padding: 8px 30px !important;
`

export const CitationStyleButton = styled(OutlineButton)`
  border-radius: 8px;
  padding: 10px !important;
`

export const ButtonText = styled.div`
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const ImageWrapper = styled.div``

const imageWrapperCss = css`
  transition: background-color 0.3s ease-in;
  padding: ${FantaTheme.spacing.fanta.xxs} ${FantaTheme.spacing.fanta.xs};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CopyImage = styled.div`
  background-image: ${`url('${publicAssetUrl('copy.svg')}');`};
  width: 20px;
  height: 24px;
`

export const CopyButton = styled(SecondaryButton)`
  font-size: 18px;
  color: ${FantaTheme.colors.dark};
  padding-left: 0;
  padding-right: 0;

  ${ImageWrapper} {
    ${imageWrapperCss}
  }

  &:hover {
    ${ImageWrapper} {
      background-color: ${FantaTheme.colors.skyLight};
    }
  }
`
export const ExportButton = styled(SecondaryButton)`
  font-size: 18px;
  color: ${FantaTheme.colors.dark};
  padding-right: 0;
  padding-left: 0;
  margin-left: ${FantaTheme.spacing.fanta.sm};

  ${ImageWrapper} {
    ${imageWrapperCss}
  }

  &:hover {
    ${ImageWrapper} {
      background-color: ${FantaTheme.colors.skyLight};
    }
  }
`

export const CitationListContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 22px;
`

export const CitationItemsContainer = styled.div``
export const CitationItemsHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const CitationItems = styled.div``

export const EmptyStateContainer = styled.div`
  display: flex;
  margin-top: ${FantaTheme.spacing.fanta.xl};
  flex-direction: column;
  align-items: center;
  > * {
    padding: 5px;
  }
`
export const EmptyStateText = styled.span`
  display: block;
  font-size: ${FantaTheme.font.text.size.md};
  font-weight: ${FantaTheme.font.weight.bold};
`
export const EmptyStateCreateCitationText = styled.span`
  display: block;
  color: ${FantaTheme.colors.dark};
  font-size: ${FantaTheme.font.text.size.md};
`
export const WorksCitedText = styled.span`
  @media (min-width: 601px) {
    margin-left: ${FantaTheme.spacing.fanta.xxxxl};
  }
  ${TimesNewRomanStack};
`
export const SortByDropdownContainer = styled.div`
  // fix odd styling issue with small size from core component
  > div > div > div > button > svg {
    position: relative;
    left: 0;
    transform: none;
  }
`
export const SortByButton = styled(SecondaryButton)`
  color: ${FantaTheme.colors.dark};
  > svg {
    margin-top: -4px;
  }
`

export const CitationFlowContainer = styled.div`
  width: 100%;
  height: 100%;

  @media (min-width: 600px) {
    width: 528px;
  }

  @media (min-width: 900px) {
    width: 609px;
  }

  @media (min-width: 1200px) {
    width: 649px;
  }
`

export const CitationDrawerHeaderWrapper = styled(PageHeaderWrapper)`
  padding: 0 2rem;

  @media screen and (max-width: 899px) {
    padding: 0 1rem;
  }
`

export const CitationFlowTitle = styled.h1`
  margin-top: ${({ theme }) => theme.spacing.lg};
  color: ${FantaTheme.colors.dark};
  ${AspiraStack};
  font-size: ${FantaTheme.font.text.size['2xl']};
  font-weight: ${FantaTheme.font.weight.bold};
  letter-spacing: 0;
  line-height: 36px;
  width: calc(100% - 48px);
  display: inline;

  @media (max-width: 600px) {
    text-align: center;
    width: auto;
  }
`

export const Chevron = styled(ChevronIcon)`
  margin-left: ${spacing.px4};
`

export const Export = styled(ExportIcon)`
  margin-top: ${spacing.px8};
  margin-right: ${spacing.px4};
`
